import { Link, useLocation } from "react-router-dom";
import moment from 'moment-timezone'; // For timezone handling
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function CourseTableRowStudent({ data,type }) {
  const { t } = useTranslation();
  const [timeRemaining, setTimeRemaining] = useState('');
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith("/app");

  useEffect(() => {
    const courseStartTimeUtc = moment.tz(data?.start_time, 'UTC');
    const interval = setInterval(() => {
      const now = moment(); // Current local time
      const diff = moment.duration(courseStartTimeUtc.diff(now)); // Difference between now and course start time

      if (diff.asSeconds() <= 0) {
        clearInterval(interval);
        setTimeRemaining('00:00:00');
      } else {
        const hours = String(Math.floor(diff.asHours())).padStart(2, '0');
        const minutes = String(diff.minutes()).padStart(2, '0');
        const seconds = String(diff.seconds()).padStart(2, '0');
        setTimeRemaining(`${hours}:${minutes}:${seconds}`);
      }
    }, 1000);

    return () => clearInterval(interval); // Clean up on component unmount
  }, []);
  return (
    <>
      <tr className="align-middle">
        {/* <td>{data?.course?.course_type == 'recorded' ? 'Recorded' : 'Live'}</td> */}
        
        {type == 'live' ? <td data-label={t("courseTableRowStudent.lesson")}>{data?.lesson?.title}</td>:''}
        <td data-label={t("courseTableRowStudent.course")}>
        <Link to={isAppRoute?`/app/course/${data?.course?.slug}`:`/course/${data?.course?.slug}`} className="course-table-img text-info">
              {data?.course?.title}
            </Link>
        </td>
        <td data-label={t("courseTableRowStudent.teacher")}>{data?.teacher?.name}</td>
        {type == 'live' ?
        <>
        
        <td data-label={t("courseTableRowStudent.start_time")}>{data?.student_local_start_time}</td>
        </>
        :
        <>
        <td data-label={t("courseTableRowStudent.total_lessons")}>{data?.course?.lessons_count}</td>
        </>}

        {type == 'live' ?
        <td className="fw-bold" data-label={t("courseTableRowStudent.remaining")}>

          {data?.course?.course_type == 'recorded' ? '' : timeRemaining}

        </td>
        :''}
       
        <td className="td-actions">
          {data?.course?.course_type == 'recorded' ?
            <>
            <Link to={`/lesson/${data?.course?.slug}/${data?.course?.trial_lessons?.id}`} className="btn btn-sm btn-primary ms-1">{t("courseTableRowStudent.details")}</Link>
            </>
            :
           <>
           {data?.status == '0' ?
            <Link to={`/room/${data?.course?.slug}/${data?.room_no}`} className="btn btn-sm btn-success">{t("courseTableRowStudent.join")}</Link>
           :''}
           </>
          }
        </td>
      </tr>
    </>
  )
}